
fx.ns("shared.popups", class SharedPhotosRefusePopup extends fx.components.Popup{
    
    constructor(model)
    {
        super();
        this.model = model;
        this._currentSharedPhotos = fx.service("PhotoSharingService").currentSharedPhotos;
        this.contentWidth = 400;
        this.contentHeight = 230;
    }

    create()
    {
        super.create();

        if(this._currentSharedPhotos)
        {
          let guestname = this._currentSharedPhotos.guestname;
  
          this.hbox_photos = new fx.components.HBox();
          this.hbox_photos.addChild(new fx.components.Text({text:fx.text("Vous allez perdre les photos partagées de $.", guestname), className:"center shareInfoText"}), {left:0, width:"100%"});
          this.hbox_photos.addChild(new fx.components.Text({text:fx.text("Êtes vous sûr de vouloir quitter?"), className:"center shareInfoText"}), {left:0, width:"100%"});

          // button   
          this.backButton = new fx.components.Button({label : fx.text("Revenir"), className : "exitButton"});
          this.hbox_photos.addChild(this.backButton, {top:70, height:60, width : 150, left: 0});

          // button   
          this.leaveButton = new fx.components.Button({label : fx.text("Quitter"), type : "filled"});
          this.hbox_photos.addChild(this.leaveButton, {top:70, height:60, width : 200, right: 0});
          
          this.addChild(this.hbox_photos, {top: 50, width: "85%", left: "center"});
        }
    }

    onReady()
    {
      this.on("click", this.onBack, this.backButton);
      this.on("click", this.onClose, this.leaveButton);
    }

    close()
    {
      super.close();
      this.model.event("show-editor");
      fx.service("PhotoSharingService").reject();
    }

    onClose(){
      this.close();
    }

    onBack(){
      super.close();
      this.model.event("shared-photos-panel");
    }
});